<template>
  <div class="page-productDetails">
    <Header :callback="getUserInfo" :showBack="true" />
    <div class="page-content">
      <div class="tab-panel" v-if="companyData">
        <div class="product-details">
          <div class="top">
            <div class="top-base">
              <img :src="companyData.pc_logo || config.DEFAULT_SHOP_LOGO" alt="" class="cover shop_logo" />
              <div class="company-info">
                <p class="name line-clamp-1">
                  {{ searchName.companyName }}
                </p>
                <p class="text">
                  <span class="product-label">There are plenty of products</span>
                  <span class="product-num">{{ companyData.quality }}</span>
                </p>
                <p class="text">
                  <span class="product-label">Supply chain support</span>
                  <span class="product-num">{{ companyData.services }}</span>
                </p>
                <p class="text">
                  <span class="product-label">Technical support</span>
                  <span class="product-num">{{ companyData.innovation }}</span>
                </p>
                <p class="text">
                  <span class="product-label">Stable supply</span>
                  <span class="product-num">{{ companyData.service }}</span>
                </p>
                <p class="text">
                  <span class="product-label">Respond quickly</span>
                  <span class="product-num">{{ companyData.performance }}</span>
                </p>
              </div>
            </div>
            <div class="subtitle" v-if="companyData.presentation">
              {{ companyData.presentation }}
            </div>
          </div>

          <!-- <div class="video-box" v-if="supplierListData ? supplierListData.length : false">
            <span class="video-label">Supplier</span>
            <div class="video-group">
              <a :href="item.url ? item.url : 'javascript:;'" v-for="(item, index) in supplierListData" :key="index">
                <img :src="item.logo" alt="" class="video-img" />
              </a>
            </div>
          </div>
          <div class="video-box" v-if="userListData ? userListData.length : false">
            <span class="video-label">Customer</span>
            <div class="video-group">
              <a :href="item.url ? item.url : 'javascript:;'" v-for="(item, index) in userListData" :key="index">
                <img :src="item.logo" alt="" class="video-img" />
              </a>
            </div>
          </div> -->
        </div>
      </div>
      <div class="tab-panel" v-else-if="distributorData">
        <div class="product-details">
          <div class="top">
            <div class="top-base">
              <img :src="distributorData.company.logo || config.DEFAULT_SHOP_LOGO" alt="" class="cover shop_logo" />
              <div class="company-info">
                <p class="name line-clamp-1">{{ distributorData.company.companyName }}</p>
                <p class="text">
                  <span class="product-label">Data warehousing</span>
                  <span class="product-num">{{ distributorData.counts }}</span>
                </p>
              </div>
            </div>
            <div class="subtitle" v-if="distributorData.company.description">
              {{ distributorData.company.description }}
            </div>
          </div>

          <div class="video-box" v-if="supplierListData ? supplierListData.length : false">
            <span class="video-label">Supplier</span>
            <div class="video-group">
              <a :href="item.url ? item.url : 'javascript:;'" v-for="(item, index) in supplierListData" :key="index">
                <img :src="item.logo" alt="" class="video-img" />
              </a>
            </div>
          </div>
          <div class="video-box" v-if="userListData ? userListData.length : false">
            <span class="video-label">Customer</span>
            <div class="video-group">
              <a :href="item.url ? item.url : 'javascript:;'" v-for="(item, index) in userListData" :key="index">
                <img :src="item.logo" alt="" class="video-img" />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="tab-view">
        <div class="tab-box">
          <div class="chemistry-product">
            <div class="item" v-for="item in warehouseProductList">
              <div class="chemistry-content">
                <p class="title">
                  <span class="text">{{ item.pName }}</span>
                  <i class="title-icon" v-if="item.recommend > 0"></i>
                </p>
                <p class="column">
                  <span class="text" v-html="'CAS:' + item.cas"></span>
                  <span class="text" v-html="'Brands:' + item.grade"></span>
                </p>
                <p class="column line-clamp-1">
                  Producers:{{ item.munAbb }}
                </p>
              </div>
              <router-link :to="{ path: '/prodetail', query: { id: item.pId, munufacturer_id: companyId } }">
                <button class="right-btn">
                  <span class="text">Find out more</span>
                  <i class="btn-icon"></i>
                </button>
              </router-link>
            </div>
            <p class="loading-text" v-show="warehousePage > 1 && !warehouseOver">Pull down to get more...</p>
          </div>
        </div>
      </div>
    </div>
    <Footer />
    <Toast :text="toastText" :visible="toastVisible" />
  </div>
</template>

<script>
  import header from '../common/header';
  import footer from '../common/footer';
  import config from '../../common/config'
  import axios from 'axios';
  import qs from 'qs';
  import toast from '../ui/toast.vue'

  export default {
    name: '',
    data() {
      return {
        config,
        id: this.$route.query.id,
        companyId: this.$route.query.companyId || '', // 公司id
        productName: '', // 商品名称
        detailsData: '', // 详情
        companyData: '', // 公司
        distributorData: null, // 经销商信息
        userListData: [], // 用户
        supplierListData: [], //供应商
        replyType: 1, // 1回復
        suplyText: '', //  提交文本
        suplyTextLength: 0,
        productId: '',
        pid: '',
        modelSampleUser: '', // 小样联系人
        modelSampleTel: '', // 小样手机
        modelSampleCompany: '', // 小样公司
        modelSampleMessage: '', // 留言
        toastText: '', // 提示内容
        toastVisible: false, // 提示框
        toastTimer: null,
        userInfo: null, // 用户信息
        warehouseProductList: [], // 入库产品
        warehousePage: 0, // 页码
        warehouseLoading: false, // 加载状态
        warehouseOver: false, // 更多数据
        searchName: {} // 企业集数据
      }
    },
    metaInfo: {
      title: 'AI Selection for Materials - from Ibuychem.com,Leading Manufacturers & Suppliers of Chemical Materials and Products in China',
      meta: [
        { name: "keywords", content: "chemical raw material, chemical properties,properties,chemical brand,coatings, inks, plastic,adhesive,PE,PP,PVC,resin,pigments, additives,TDS,MSDS,SDS" },
        { name: "description", content: "Provide performance tables for over 200000 types of chemical raw materials, and continuously improve and add new ones. You can directly search and browse online or print and read the product performance table you have found. The current  performance table parameters include injection molding parameters, plastic melt index, hardness, flow index, plastic raw material usage, etc; The chemical performance table parameters include: content, dosage PH、 Formulas, alternative products, etc." }
      ]
    },
    created() {
      window.scrollTo(0, 0);
      _hmt.push(['_trackPageview', `/${window.location.hash}`]);

      this.getComponentInfo();
      this.getUserList();
      this.getWarehouseProduct();
    },
    mounted() {
      window.addEventListener('scroll', this.handleScroll);
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
      toast(text) {
        this.toastText = text;
        this.toastVisible = true;
        if (this.toastTimer) clearTimeout(this.toastTimer);
        this.toastTimer = setTimeout(() => {
          this.toastText = '';
          this.toastVisible = false;
        }, 2000);
      },
      /**
       * 用户信息
       * @param {Object} data 用户信息
       */
      getUserInfo(data) {
        this.userInfo = data;
        this.modelSampleUser = data.name;
        this.modelSampleTel = data.mobile;
        this.modelSampleCompany = data.company;
      },
      // 公司
      getComponentInfo(id) {
        axios.post(config.MallApi + 'api/wshop/shop/shop-visiting-card', qs.stringify({
          companyId: this.companyId,
        })).then(res => {
          if (res.data.error_code === 0) {
            this.companyData = res.data.data;

            var _title = res.data.data.common_service;

            WeChatShare({
              callback: () => {
                var desc = res.data.data.presentation || '';
                var imgUrl = config.PHPHOST + 'frontend/web/images/logo-new.jpg';
                var link = window.location.origin + '/#/companyDetails?companyId=' + this.companyId;

                wx.onMenuShareAppMessage({
                  title: _title,
                  desc: desc,
                  link: link,
                  imgUrl: imgUrl
                });
                wx.onMenuShareTimeline({
                  title: _title,
                  desc: desc,
                  link: link,
                  imgUrl: imgUrl
                });
              },
              data: 'url=' + encodeURIComponent(window.location.href),
              url: config.MAPI
            })
          } else {
            this.getDistributor();
          }
        });
      },
      // 获取经销商信息
      getDistributor() {
        axios.post(config.PHPHOST + 'api/web/index.php?r=company/company-particulars&partId=' + this.companyId + '&edition=2').then(r => {
          r = r.data;
          if (r.flag === 0) {
            this.distributorData = r.data;

            var _title = r.data.company.companyName;
            var desc = r.data.company.description || '';
            var imgUrl = config.PHPHOST + 'frontend/web/images/logo-new.jpg';
            var link = window.location.origin + '/#/companyDetails?companyId=' + this.companyId;
            WeChatShare({
              callback: () => {
                wx.onMenuShareAppMessage({
                  title: _title,
                  desc: desc,
                  link: link,
                  imgUrl: imgUrl
                });
                wx.onMenuShareTimeline({
                  title: _title,
                  desc: desc,
                  link: link,
                  imgUrl: imgUrl
                });
              },
              data: 'url=' + encodeURIComponent(window.location.href),
              url: config.MAPI
            })
          }
        });
      },
      // 客户
      getUserList(id) {
        axios.get(config.MallApi + 'api/wshop/shop/supplier-customers?companyId=' + this.companyId).then(res => {
          if (res.data.error_code === 0) {
            this.userListData = res.data.data.preferred_customers;
            this.supplierListData = res.data.data.material_supplier;
          }
        })
      },

      /**
       * 跳转到店铺
       * @param {Object} url 店铺链接
       */
      gotoShop(url) {
        window.location.href = url;
      },
      // 获取入库产品
      getWarehouseProduct(id) {
        if (this.warehouseLoading || this.warehouseOver) return;
        this.warehouseLoading = true;
        this.warehousePage++;
        axios.get(config.PHPHOST + 'api/web/index.php?r=company/company-product-list&partId=' + this.companyId + '&page=' + this.warehousePage).then(res => {
          if (res.data.flag === 0) {
            this.warehouseLoading = false;
            this.searchName = res.data.data.searchName
            this.warehouseProductList = this.warehouseProductList.concat(res.data.data.product);
            if (this.warehousePage >= res.data.data.page_count) {
              this.warehouseOver = true;
            }
          }
        })
      },
      /**
       * [handleScroll 滚动加载数据]
       * @return null
       */
      handleScroll() {
        if (this.warehouseLoading || this.warehouseOver) return;
        if (document.body.scrollHeight - document.body.scrollTop - window.innerHeight < 150 || document.body.scrollHeight - document.documentElement.scrollTop - window.innerHeight < 150) {
          this.getWarehouseProduct();
        }
      }
    },
    components: {
      Header: header,
      Footer: footer,
      Toast: toast
    },
  }
</script>


<style scoped lang="less">
  .page-productDetails {
    background: #0a1a5d;
    font-size: 1.2rem;
    color: #333;
    font-family: '微软雅黑';
    display: flex;
    flex-direction: column;
    height: 100%;

    button,
    textarea,
    input {
      outline: none;
      box-sizing: border-box;
    }

    .line-clamp-3 {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 3;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .line-clamp-2 {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      text-overflow: ellipsis;
      overflow: hidden;
    }


    .page-content {
      position: relative;
      background: #f8f8f8;
      border-top-left-radius: 2.92rem;
      border-top-right-radius: 2.92rem;
      padding: 1.75rem 1.75rem 0;
      flex: 1;

      .get-invoice {
        position: absolute;
        right: 2.33rem;
        top: 0;
        width: 4.58rem;
        height: 5.83rem;
        background: url('../../assets/images/invoice_bg.png') no-repeat scroll top/cover;
        text-align: center;

        .invoice-icon {
          width: 1.25rem;
          height: 1.25rem;
          display: inline-block;
          margin-top: 1.08rem;
          background: url('../../assets/images/search_white.png') no-repeat scroll top/cover;
        }

        .invoice-text {
          width: 3rem;
          display: inline-block;
          color: #fff;
          font-weight: 900;
          transform: scale(.8);
        }
      }

    }



    .text-center {
      text-align: center;
    }

    .block {
      display: block !important;
    }

    .dialog {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, .5);
      z-index: 1000;

      &.dialog-big {
        .dialog-content {
          width: 80%;

          .my-score {
            width: 100%;
          }

          .score-submit {
            height: 3.2rem;
          }
        }

        .invoice-form {
          .form-input-warrper {
            margin-top: 1rem;

            .label {
              padding-bottom: 1rem;
            }

            .input {
              height: 3.2rem;
            }
          }
        }
      }

      .dialog-content {
        position: relative;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: inline-block;
      }

      .dialog-close {
        position: absolute;
        right: -1.2rem;
        top: -1.2rem;
        width: 3.33rem;
        height: 3.33rem;
        display: inline-block;
        background: url('../../assets/images/close.png') no-repeat scroll top/cover;
      }

      .my-score {
        width: 21rem;
        background: #fff;
        border-radius: 0.58rem;
        overflow: hidden;

        .my-score-title {
          line-height: 3.75rem;
          text-align: center;
          background: #eaedf7;
          color: #0c2870;
          font-size: 1.4rem;
        }

        .score-group {
          padding: 3.25rem 1.6rem 2.58rem;
          overflow: hidden;

          .score-item {
            padding: 0 1rem;
            margin-bottom: 2.58rem;

            .score-title {
              color: #49557f;
            }

            .score-box {
              display: flex;
              margin-top: 0.83rem;
              justify-content: space-between;

              .scores {}

              .score-img {
                width: 1.54rem;
                height: 1.54rem;
                margin-right: 0.83rem;
              }

              .num {
                font-size: 1.6rem;
                font-weight: 900;
                line-height: 1.54rem;
                color: #001eed;

              }
            }
          }
        }

        .score-submit {
          width: 100%;
          height: 2.8rem;
          background: #597eff;
          color: #fff;
          border: 0;
          font-size: 1.4rem;
          border-radius: 2.33rem;
        }
      }

      .invoice-form {
        padding: 1.75rem 2.08rem 1.8rem;

        .form-input-warrper {
          margin-bottom: 0.6rem;

          .label {
            padding-bottom: 0.45rem;
            color: #666;
          }

          .input {
            width: 100%;
            height: 2.5rem;
            padding: 0 0.5rem;
            border: 0.045rem solid #c7c7c7;
            border-radius: 0.25rem;

            &:focus {
              border: 0.045rem solid #a6bbff;
            }
          }

          .textarea {
            width: 100%;
            height: 6.1rem;
            border: 0.045rem solid #c7c7c7;
            border-radius: 0.25rem;
            padding: 0.5rem;

            &:focus {
              border: 0.045rem solid #a6bbff;
            }
          }
        }
      }
    }


    .top-base {
      .info-content {
        padding: 0 5rem 0 1rem;
      }

      .top-title {
        font-size: 2rem;
        font-weight: 900;
        line-height: 2rem;
      }

      .subtitle {
        padding-top: 1rem;
        font-size: 1.2rem;
        line-height: 1.5rem;
        margin-bottom: 1.5rem;

        .company {
          font-size: 1.2rem;
          font-weight: 900;
          margin: 0 0.42rem 0 0.84rem;
        }

        .company-icon {
          width: 1.25rem;
          height: 1.17rem;
          display: inline-block;
          margin-right: 0.82rem;
          background: url('../../assets/images/company.png') no-repeat scroll center/cover;
          vertical-align: text-bottom;
        }
      }

      .cas {
        padding: 0 0 1.5rem;
        font-size: 1.2rem;
      }

      .info {
        margin-bottom: 1.5rem;

        .label {
          margin-right: 0.33rem;
          font-size: 1.2rem;
          color: #999;
        }

        .text {
          margin-right: 1.625rem;
          font-size: 1.2rem;
        }
      }

      .score {
        padding: 2.08rem 0 0 1rem;
        display: flex;

        .score-item {
          position: relative;
          flex: 1 1;
          padding: 0 2% 0 6%;
          font-size: 1.2rem;

          &:first-child {
            padding-left: 0;
          }

          &:after {
            content: '';
            position: absolute;
            bottom: 0;
            right: 0;
            width: 0.084rem;
            height: 1.875rem;
            display: inline-block;
            background: #e6e6e6;
          }

          .score-title {
            color: #999;
          }

          .start {
            float: left;
            padding-top: 0.5rem;
            vertical-align: text-bottom;

            .start-img {
              width: 0.84rem;
              height: 0.84rem;
              margin-right: 0.23rem;
            }
          }

          .num {
            float: left;
            margin-top: 0.5rem;
            margin-left: 0.21rem;
            font-weight: 900;
            color: #666;
          }
        }
      }

      .go-grade {
        width: 27.5%;
        font-size: 1.2rem;
        line-height: 2.5rem;
        text-align: right;

        .grade-icon {
          width: 1.29rem;
          height: 0.71rem;
          display: inline-block;
          margin-left: 0.14rem;
          background: url('../../assets/images/right_blue.png') no-repeat scroll center/cover;
        }
      }
    }

    .tab-btn {
      height: 3.8rem;
      display: flex;
      padding: 0 0.6rem;
      margin: 1.66rem 0;
      border-radius: 2.5rem;
      background: url('../../assets/images/tab_bg.png') no-repeat scroll top/cover;
      background-size: 100% 100%;
      align-items: center;

      .btn-item {
        flex: 1 1;
        height: 3.1rem;
        margin-right: 0.58rem;
        border-radius: 1.8rem;
        text-align: center;
        line-height: 3.1rem;
        color: #525252;

        &.active {
          background: #597eff;
          color: #fff;
          border: 0.05rem solid #fff;
          font-weight: 900;
        }

        &:last-child {
          margin-right: 0;
        }
      }
    }

    .tab-view {
      overflow: hidden;

      .relative {
        position: relative;
      }

      .suply-btn {
        position: absolute;
        top: 1.66rem;
        right: 0;
        width: 4.16rem;
        height: 4.16rem;
        display: inline-block;
        background: url('../../assets/images/suply_btn.png') no-repeat scroll top/cover;
      }
    }

    .chemistry-product {
      .loading-text {
        padding: 1.7rem 0 3.45rem;
        font-size: 1.2rem;
        line-height: 1.4rem;
        color: #666;
        text-align: center;
      }

      .item {
        position: relative;
        display: flex;
        height: 9.1rem;
        padding: 0.5rem 0.5rem 0.5rem 1.8rem;
        margin-bottom: 1.8rem;
        border-radius: 1rem;
        background: #fff;
        box-shadow: 0 0.8rem 2rem 0px rgba(0, 0, 0, 0.06);

        &:before {
          content: '';
          position: absolute;
          top: 1.1rem;
          left: 0;
          width: 0.25rem;
          height: 2.6rem;
          display: inline-block;
          border-radius: 0.1rem;
          background: #4871ff;

        }

        .chemistry-content {
          flex: 1 1 20%;
          width: 20%;
          padding-right: 1rem;

          .title {
            padding: 1rem 0 0.4rem;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;

            .text {
              font-size: 1.7rem;
              line-height: 1.8rem;
              font-weight: bold;
            }

            .title-icon {
              width: 3.1rem;
              height: 1.5rem;
              display: inline-block;
              margin: 0.2rem 0 0 0.5rem;
              background: url('../../assets/images/icon-yl.png') no-repeat scroll top/cover;
              vertical-align: top;
            }
          }

          .column {
            padding-top: 0.9rem;
            font-size: 1.2rem;
            line-height: 1.4rem;
            color: #999;

            .text {
              &:first-child {
                margin-right: 1.5rem;
              }
            }
          }
        }

        .right-btn {
          width: 5.2rem;
          height: 100%;
          border: 0;
          padding: 0 1.2rem;
          border-radius: 0.6rem;
          background: #f0f2f7;
          font-size: 1.3rem;
          line-height: 2.2rem;
          color: #979db8;

          .btn-icon {
            width: 2rem;
            height: 0.8rem;
            display: block;
            margin: 0.6rem auto 0;
            background: url('../../assets/images/nicon-search-view-detail.png') no-repeat scroll top/cover;
          }
        }
      }
    }

    .tab-panel {
      background: #fff;
      padding: 1.45rem 1.25rem 1.7rem;
      border-radius: 1rem;
      margin-bottom: 1.83rem;
      box-shadow: 2px 2px 6px #ededed;

      .product-details {
        .top {
          padding: 1.75rem 1.6rem 1.4rem;
          background: #f2f4fb;
          border-radius: 0.5rem;

          .top-base {
            display: flex;
            align-items: center;
          }

          .subtitle {
            padding-top: 0.4rem;
            font-size: 1.4rem;
            line-height: 2.1rem;
          }

          .cover {
            width: 7.29rem;
            height: 7.29rem;
            margin-right: 1.25rem;
          }

          .company-info {
            flex: 1 1;
            width: 20%;

            .name {
              padding: 0.625rem 0 1.08rem;
              font-size: 1.4rem;
              font-weight: bold;
            }

            .text {
              float: left;
              min-width: 50%;
              overflow: hidden;
              margin-bottom: 1rem;
            }

            .product-label {
              float: left;
              margin-right: 0.35rem;
              color: #999;

            }

            .product-num {
              float: left;
              color: #555;
              font-weight: 600;
            }
          }
        }

        .video-box {
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: space-around;
          margin-top: 1.75rem;

          &:last-child {
            margin-bottom: 0.7rem;
          }

          .video-label {
            width: 5rem;
            height: 1.91rem;
            display: inline-block;
            font-size: 1rem;
            line-height: 1.91rem;
            text-align: center;
            border: 0.05rem solid #bababa;
            border-radius: 1.6rem;
            color: #999;
            margin-right: 1rem;
          }

          .video-group {
            flex: 1;

            .video-img {
              width: 4.25rem;
              height: 4.25rem;
              margin-right: 0.75rem;
              margin-bottom: .5rem;
            }

            a:last-child {
              .video-img {
                margin-right: 0;
              }

            }
          }

          .video-next {
            width: 0.58rem;
            height: 0.95rem;
            display: inline-block;
            margin-right: 0.2rem;
            background: url('../../assets/images/right_black.png') no-repeat scroll center/cover;
          }
        }
      }

      .panel-title {
        padding: 1.2rem 0 .5rem 0.66rem;
        font-size: 1.5rem;
        color: #000b5d;
      }

      .product-info {
        display: flex;
        padding: 0.66rem;
        margin-top: 1.33rem;
        background: #f2f4fb;
        border-radius: 0.33rem;
        text-align: center;

        .info {
          flex: 1 1;
          font-size: 1.2rem;

          .info-title {
            color: #999;
          }

          .info-name {
            font-size: 1.3rem;
            padding-top: 0.66rem;
            line-height: 1.5rem;
          }
        }
      }

      .product-type {
        padding: 1.66rem 0 0 0.66rem;

        .type {
          overflow: hidden;
          margin-bottom: 1rem;
          line-height: 1.6rem;

          .label {
            float: left;
            margin-right: 0.79rem;
          }

          .type-list {
            float: left;

            li {
              margin-bottom: 0.58rem;
              font-size: 1.3rem;
              line-height: 1.6rem;
            }

            .gray {
              margin: 0 0.625rem;
              color: #999;
            }
          }
        }
      }

      .characteristic {
        padding: 0.66rem;
        background: #f2f4fb;
        border-radius: 0.33rem;
        margin-bottom: 1.5rem;

        .characteristic-title {
          color: #999;
        }

        .text {
          padding-top: 0.66rem;
          font-size: 1.3rem;
          line-height: 2.3rem;
          word-break: break-all;
        }
      }

      .parameter {
        padding: 0.66rem 0 0.41rem 0.66rem;

        .parameter-item {
          display: inline-block;

          .label {
            margin-right: 0.41rem;
            color: #999;
          }

          .text {
            margin-right: 0.75rem;
          }
        }
      }

      .documents {
        padding: 1.5rem 0 0 0.66rem;

        .item {
          display: flex;
          align-items: center;
          margin-bottom: 1.33rem;

          .documents-img {
            width: 1.58rem;
            height: 1.66rem;
            display: inline-block;
            margin-right: 0.625rem;
            vertical-align: text-bottom;
          }

          .documents-info {
            display: inline-block;
            color: #666;
            flex: 1 1;
            min-width: 20%;

            .name {
              line-height: 1.3rem;
            }
          }
        }
      }

      .base-list {
        padding: 1.06rem 0 0 0.66rem;

        li {
          display: inline-block;
          margin: 0 1.5rem 0.5rem 0;
          overflow: hidden;

          .label {
            color: #999;
            margin-right: 0.42rem;
            float: left;
          }

          .text {
            margin-right: 1rem;
            font-size: 1.2rem;
          }
        }
      }

      .formula-table {
        padding-top: 1.16rem;

        .thead {
          padding: 0;
          background: #f2f4fb;
          border-radius: .5rem;
        }

        .tbody {

          .tr {
            border-bottom: 0.08rem dashed #cbcbcb;

            &:last-child {
              border-bottom: 0;
            }
          }
        }

        .tr {
          display: flex;
          text-align: center;
          padding: 5px 0;

          .th {
            flex: 1 1;
            padding: 0 0.5rem;
            min-height: 2rem;
            line-height: 2rem;
            color: #999;

            &:first-child,
            &:last-child {
              width: 30%;
            }
          }

          .td {
            flex: 1 1;
            padding: 0 0.5rem;
            line-height: 3.2rem;
            word-break: break-all;

            &:first-child,
            &:last-child {
              width: 20%;
            }
          }
        }
      }

    }

    .more-btn {
      display: block;
      width: 17.4rem;
      height: 3.45rem;
      margin: 2rem auto 0 auto;
      background-color: #fff;
      text-align: center;
      border-radius: 2rem;
      line-height: 3.45rem;
      margin-bottom: 3.3rem;
      color: #0c2870;
      font-size: 1.3rem;

      img {
        display: block;
        width: 100%;
      }
    }

    .tab-box {
      .supply-warrper {
        .supply-item {
          display: flex;
          padding: 0.8rem 0.75rem 0.7rem 2.9rem;
          margin-bottom: 1.5rem;

          .supply-title {
            padding: 1.6rem 1.5rem 0 0;
            font-size: 1.7rem;
            font-weight: 400;
          }

          .supply-left {
            flex: 1 1;
            width: 20%;

            .supply-info {
              display: inline-block;
              overflow: hidden;
              padding-top: 1.6rem;
            }

            .supply-label {
              float: left;
              margin: 0 0.33rem 0 0;
              color: #999;
              font-size: 1.3rem;
              line-height: 1.5rem;
            }

            .blue {
              color: #4e75ff;
              font-weight: bold;
            }

            .blod {
              font-weight: bold;
            }

            .supply-text {
              float: left;
              margin: 0 1.5rem 0 0;
              font-size: 1.5rem;

              .price {
                font-style: normal;
              }
            }
          }

          .supply-btn {
            width: 7.5rem;
            height: 8rem;
            border: 0;
            background: #f0f2f7;
            font-size: 1.7rem;
            color: #a0a7be;
            font-weight: bold;
            border-radius: 1rem;
          }
        }
      }

      .interact {
        .interact-list {
          padding: 1.33rem 0;
          border-bottom: 0.08rem solid #efefef;

          .interact-item {
            margin-bottom: 1.5rem;

            &:last-child {
              margin-bottom: 0;
            }

            .user {
              overflow: hidden;
              padding-left: 0.66rem;

              .user-info {
                .cover {
                  float: left;
                  width: 2.66rem;
                  height: 2.66rem;
                  margin-right: 0.66rem;
                }

                .base {
                  float: left;
                }

                .name {
                  padding-top: 0.2rem;
                  font-weight: 600;

                  &.expert {
                    color: #164aff;
                  }
                }

                .time {
                  padding-top: 0.2rem;
                  color: #666;
                }
              }

              .reply-btn {
                float: right;

                .icon {
                  width: 0.83rem;
                  height: 0.71rem;
                  display: inline-block;
                  margin: 1.51rem 0.41rem 0 0;
                  background: url('../../assets/images/message.png') no-repeat scroll top/cover;
                }

                .reply-text {
                  color: #164aff;
                }
              }
            }

            .interact-warrper {
              overflow: hidden;
              padding: 1.04rem 0 0 0.66rem;

              .interact-text {
                color: #666;
                line-height: 1.6rem;
                word-break: break-all;
              }

              .show-btn {
                float: right;
                padding: 0 0.8rem 0 1.6rem;
                line-height: 1.6rem;
                font-weight: bold;
              }
            }

            .other-reply {
              padding: 1.25rem 0;
              margin-top: 1.66rem;
              background: #f6f7fa;

              .get-more {
                padding-top: 0;
              }
            }
          }
        }

        .get-more {
          padding-top: 1.75rem;
          text-align: center;
          font-size: 1.3rem;
          line-height: 1.3rem;

          .more-icon {
            width: 0.58rem;
            height: 1.16rem;
            display: inline-block;
            margin-left: 0.5rem;
            background: url('../../assets/images/more_icon.png') no-repeat scroll top/cover;
            vertical-align: text-bottom;
          }
        }
      }

      .recommed-list {
        overflow: hidden;

        .recommed-warrper {
          width: 50%;
          float: left;

          .recommend-item {
            padding: 1.33rem 1rem 1.16rem;
            height: 9.2rem;

            &:nth-of-type(2n) {
              background: #f6f7fa;
            }

            .recommend-title-warrper {
              height: 4.16rem;
              margin-bottom: 1rem;
            }

            .recommend-title {
              padding: 0 0 0 0.83rem;
              word-break: break-all;
              font-size: 1.7rem;
              font-weight: bold;
              line-height: 2.2rem;
              border-left: 0.16rem solid #5178ff;
            }

            .recommend-text {
              padding: 0 0 0.5rem 0.83rem;
              color: #999;
            }
          }
        }
      }

      .classroom-list {
        .item {
          border-radius: 1.5rem;
          overflow: hidden;
          margin-bottom: 2.65rem;
          background: #fff;
          box-shadow: 2px 2px 6px #ededed;

          .cover {
            width: 100%;
            display: block;
          }

          .calss-title {
            padding: 1.8rem 1.8rem 0;
            font-size: 1.6rem;
            line-height: 2rem;
            font-weight: bold;
          }

          .teacher {
            padding: 1.2rem 1.8rem 1.7rem;
            font-size: 1.4rem;
            line-height: 1.8rem;
            color: #999;
          }
        }
      }
    }

    .recommed-more-btn {
      width: 12.33rem;
      height: 2.5rem;
      margin-bottom: 2.08rem;
      border: 0;
      border-radius: 1.8rem;
      background: #fff;
      color: #344780;
      font-size: 1.3rem;
      box-shadow: 0 6px 18px #dfdfdf;
    }

    .null-box {
      padding: 1rem 0 2rem;
      text-align: center;

      .null-icon {
        width: 12rem;
        height: 12rem;
        display: inline-block;
        background: url('../../assets/images/null.png') no-repeat scroll top/cover;
      }
    }
  }

  .shop_logo {
    border-radius: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/company/company-details.vue